export const faqData = [
  {
    id: 1,
    question: "How is the EMI for HDFC Bank Personal Loan calculated?",
    answer:
      "The EMI is calculated using the principal loan amount, interest rate, and loan tenure. The formula used is based on the standard EMI calculation formula:",
    answerTwo:
      "EMI=P×r×(1+r)n(1+r)n−1EMI = \frac{P \times r \times (1 + r)^n}{(1 + r)^n - 1}   ",
    answerThree: "Where: ",
    answerList: [
      {
        info: "P = Loan amount",
      },
      {
        info: "r = Monthly interest rate (annual rate divided by 12)",
      },
      {
        info: "n = Loan tenure (in months)",
      },
    ],
  },
  {
    id: 2,
    question: "What is the processing fee for HDFC Bank Personal Loan?",
    answer:
      "HDFC Bank charges a processing fee of 1% to 2.5% of the loan amount. This fee is deducted upfront from the loan amount.",
  },
  {
    id: 3,
    question: "Can I change my loan tenure after approval?",
    answer:
      "Once your loan is approved and disbursed, the tenure generally cannot be changed. However, you may be able to prepay part of the loan to reduce the outstanding principal and lower the EMI in the future.",
  },
  {
    id: 4,
    question: "Can I apply for an HDFC Bank Personal Loan online?",
    answer:
      "Yes, you can apply for a personal loan through the HDFC Bank website or mobile app. The process is quick and can be completed without visiting a branch.",
  },
];
